import { useEffect, useState } from "react";
import { Settings, Sparkles } from "lucide-react";
import QuickStatCard from "../../../components/marketing/cloud-dashboard/quick-stat";
import CommunicationChannels from "../../../components/marketing/cloud-dashboard/channel";
import ChannelPerformance from "../../../components/marketing/cloud-dashboard/channel-performance";
import useRequest from "../../../components/hook/use-req";
import { DashboardOverviewData, DashboardOverviewResponse } from "./types";


interface Channel {
  id: string;
  label: string;
  status: 'active' | 'setup' | 'inactive';
  path: string;
}

const CPaaSDashboardRedirect = () => {
    const token = localStorage.getItem("authToken");
  const [stats, setStats] = useState({
    total_messages: 0,
    campaign_messages: 0,
    transactional_messages: 0,
    total_voice_calls: 0,
  });
  // The `channels` per-communication-channel breakdown (email/rcs/sms/
  // whatsapp) that /reports/analytics/overview now returns alongside the
  // flat totals it already had.
  const [channelPerformance, setChannelPerformance] = useState<DashboardOverviewData["channels"] | null>(null);
  const { makeRequest: getDashboardStat } = useRequest(`/reports/analytics/overview`, "GET", {
    Authorization: `Bearer ${token}`,
  });
  const [channels] = useState<Channel[]>([
    { id: 'sms', label: 'SMS', status: 'active', path: '/dashboard' },
    { id: 'whatsapp', label: 'WhatsApp', status: 'active', path: '/whatsapp-setup' },
    { id: 'email', label: 'Email', status: 'active', path: '/email' },
    { id: 'rcs', label: 'RCS', status: 'setup', path: '/rcs-setup' },
    { id: 'voice', label: 'Voice', status: 'active', path: '/voice' },
    { id: 'webchat', label: 'Web Chat', status: 'setup', path: '/webchat-setup' },
    { id: 'telegram', label: 'Telegram', status: 'inactive', path: '/telegram-setup' }
  ]);
  

    useEffect(() => {
      const fetchData = async () => {
        const [response] = (await getDashboardStat()) as [DashboardOverviewResponse, number];
        const totals = response?.data?.totals;
        if (totals) {
          setStats({
            total_messages: totals.messages,
            campaign_messages: totals.campaign_messages,
            transactional_messages: totals.transactional_messages,
            total_voice_calls: totals.voice_calls,
          });
        }
        setChannelPerformance(response?.data?.channels ?? null);
      };
      fetchData();
    }, []);
    
  const handleChannelClick = (channelId: string) => {

    // Handle channel click logic here
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 dark:from-gray-950 dark:via-gray-950 dark:to-gray-950">
      {/* Header */}
      <header className="bg-white/80 dark:bg-gray-900/80 backdrop-blur-md border-b border-slate-200 dark:border-gray-800 shadow-sm sticky top-0 ">
        <div className=" mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center">
                <Sparkles className="w-6 h-6 text-white" />
              </div>
              <div>
                <h1 className="text-2xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 dark:from-gray-100 dark:to-gray-300 bg-clip-text text-transparent">
                  ConvoHub
                </h1>
                <p className="text-sm text-slate-500 dark:text-gray-400">
                  AI-Powered Communication Platform
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <button className="p-2 hover:bg-slate-100 dark:hover:bg-gray-800 rounded-lg transition-colors">
                <Settings className="w-5 h-5 text-slate-600 dark:text-gray-400" />
              </button>
            </div>
          </div>
        </div>
      </header>

      <div className="mx-auto px-6 py-8">
        {/* Hero Section */}
        <div className="mb-12">
          {/* Quick Stats */}
          <QuickStatCard {...stats} />
        </div>

        <ChannelPerformance channels={channelPerformance} />
{/* 
        <CommunicationChannels
          channels={channels}
          onChannelClick={handleChannelClick}
        /> */}
      </div>

    </div>
  );
};

export default CPaaSDashboardRedirect;
